import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const VinylWindowsPage = lazy(() => import('../pages/vinyl-windows/page'));
const AluminumWindowsPage = lazy(() => import('../pages/aluminum-windows/page'));
const SlidingDoorsPage = lazy(() => import('../pages/sliding-doors/page'));
const FrenchDoorsPage = lazy(() => import('../pages/french-doors/page'));
const ShowerDoorsPage = lazy(() => import('../pages/shower-doors/page'));
const WoodWindowsDoorsPage = lazy(() => import('../pages/wood-windows-doors/page'));
const FiberglassEntryDoorsPage = lazy(() => import('../pages/fiberglass-entry-doors/page'));
const CommercialGlassPage = lazy(() => import('../pages/commercial-glass/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/vinyl-windows',
    element: <VinylWindowsPage />
  },
  {
    path: '/aluminum-windows',
    element: <AluminumWindowsPage />
  },
  {
    path: '/sliding-doors',
    element: <SlidingDoorsPage />
  },
  {
    path: '/french-doors',
    element: <FrenchDoorsPage />
  },
  {
    path: '/shower-doors',
    element: <ShowerDoorsPage />
  },
  {
    path: '/wood-windows-doors',
    element: <WoodWindowsDoorsPage />
  },
  {
    path: '/fiberglass-entry-doors',
    element: <FiberglassEntryDoorsPage />
  },
  {
    path: '/commercial-glass',
    element: <CommercialGlassPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;